import { render, staticRenderFns } from "./ProtectedPropertyItems.vue?vue&type=template&id=36536074&"
import script from "./ProtectedPropertyItems.vue?vue&type=script&lang=js&"
export * from "./ProtectedPropertyItems.vue?vue&type=script&lang=js&"
import style0 from "./ProtectedPropertyItems.vue?vue&type=style&index=0&id=36536074&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports